import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import { currencyFromISO } from "@/utils/currency";
import useTranslation from "@babackapp/translations/use-translation";

export function useOptions() {
  const { data: shop } = useCurrentShopSuspense();
  const t = useTranslation();

  return {
    discountAvailabilityOptions: [
      { label: t("settings.config.nolimit"), key: -1 },
      { label: "1 " + t("misc.month"), key: 1 },
      { label: "3 " + t("misc.month"), key: 3 },
      { label: "6 " + t("misc.month"), key: 6 },
      { label: "12 " + t("misc.month"), key: 12 },
    ],
    discountBonusOptions: [
      {
        label: t("settings.config.percentage"),
        key: "percentage",
        suffix: "%",
      },
      {
        label: t("settings.config.fixedAmount"),
        key: "fixed_amount",
        suffix: shop ? currencyFromISO(shop.preferences.currency) : "",
      },
    ],
    giftCardOptions: [
      {
        label: t("settings.config.discountTitle"),
        key: "discount",
      },
      { label: t("settings.config.giftcard"), key: "giftCard" },
    ],
  };
}
